// src/Contexts/EventMembersContext.js

import { createContext, useEffect, useState } from "react";
import { subscribeToEventMembersData } from "../utils/fetchEventMembersData";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const EventMembersContext = createContext();

const EventMembersProvider = ({ children }) => {
  const [eventMembersList, setEventMembersList] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);

  // 認証状態の監視
  useEffect(() => {
    const auth = getAuth();
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return () => unsubscribeAuth();
  }, []);

  // 認証後にのみ eventMembers を購読
  useEffect(() => {
    if (!currentUser) return;

    const unsubscribeEventMembers =
      subscribeToEventMembersData(setEventMembersList);

    return () => unsubscribeEventMembers();
  }, [currentUser]);

  return (
    <EventMembersContext.Provider
      value={{ eventMembersList, setEventMembersList }}
    >
      {children}
    </EventMembersContext.Provider>
  );
};

export { EventMembersContext, EventMembersProvider };
